module.exports = __webpack_public_path__ + "static/media/barkbliss-2.0013d2ae.jpg";